import { Tooltip } from '@mui/material';
import React from 'react';

import * as S from './styles';

interface TextWithTooltipCellProps {
  value: string;
}

const TextWithTooltipCell: React.FunctionComponent<TextWithTooltipCellProps> = (
  props,
) => {
  const { value } = props;

  return (
    <Tooltip arrow placement="top" title={value}>
      <S.TextCellWithTooltip>{value}</S.TextCellWithTooltip>
    </Tooltip>
  );
};

export default TextWithTooltipCell;
